export default {
  setDropdownCustomItems(defaultItems, customItems) {
    const result = [
      {
        title: "建議風險",
        menu: this.setItems(defaultItems),
      },
      {
        title: "自訂風險",
        menu: this.setItems(customItems),
        isCustom: true,
      },
    ];
    return result;
  },
  setItems(rawItems) {
    const result = rawItems.map(item => {
      return {
        text: item.name,
        value: item.id,
        sequence: item.sequence
        ? item.sequence
        : null,
      }
    });
    return result;
  }
}